import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';
import ReactTooltip from 'react-tooltip'
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import CerseActions from '../../actions/CerseActions';
import CerseStore from '../../stores/CerseStore';

class Page extends Component {
  state = {
    showInfo: false,
    content: CerseStore.getState().formsContent,
    separator: CerseStore.getState().csvArraySeparator,
    methods: CerseStore.getState().methods,
    phases: CerseStore.getState().phases,
    objectives: CerseStore.getState().objectives,
    maturity: CerseStore.getState().maturity,
    articles: CerseStore.getState().articles,
    currentArticle: {}
  };

  constructor() {
    super();

    this.onChangeCerse = this.onChangeCerse.bind(this);

    this.process(this.state.content);
  }

  assign(assign) {
    let newContent = Object.assign(this.state.content, assign);

    this.setState({
      content: newContent
    });

    CerseActions.saveFormsContent(newContent);

    this.process(newContent);
  }

  componentDidMount() {
    CerseStore.listen(this.onChangeCerse);
  }

  componentWillUnmount() {
    CerseStore.unlisten(this.onChangeCerse);
  }

  onChangeCerse(store) {
    if (!(this.state.articles||[]).length)
      this.setState({
          articles: store.articles
      });
  }

  intersection(items,store) {
    return store.filter(storeLinha =>
      items.find(item => storeLinha.value === item) !== undefined
    );
  }

  process(newContent) {
    new Promise((res, rej) => {
      setTimeout(() => {
        newContent.articlesProcessed = this.state.articles
          .filter(article => this.processFilter(article, newContent))
          .sort((l, r) => this.processSort(l, r, newContent));

        this.setState({
          content: newContent
        });

        CerseActions.saveFormsContent(newContent);

        res();
      }, 200)
    });
  }

  processFilter(article, content) {
    if (!content) content =  this.state.content;

    if (content.methods.length && this.intersection(article.methods.split(this.state.separator), content.methods).length === 0) {
      return false
    }
    if (content.phases.length && this.intersection(article.phases.split(this.state.separator), content.phases).length === 0) {
      return false
    }
    if (content.objectives.length && this.intersection(article.objective.split(this.state.separator), content.objectives).length === 0) {
      return false
    }
    return true;
  }

  processSort(articleL, articleR, content) {
    if (!content) content =  this.state.content;

    let sortPoint = 0;
    if (content.methods.length) {
      sortPoint += 1000 * (
        this.intersection(articleR.methods.split(this.state.separator), content.methods).length
        -
        this.intersection(articleL.methods.split(this.state.separator), content.methods).length
      );
    }
    let lsplit = articleL.phases.split(this.state.separator);
    let rsplit = articleR.phases.split(this.state.separator);
    if (content.phases.length) {
      let lint = this.intersection(lsplit, content.phases).length;
      let rint = this.intersection(rsplit, content.phases).length;

      sortPoint += 100 * (
        (rint  - (rsplit.length - rint))
        -
        (lint  - (lsplit.length - lint))
      );
    } else {
      sortPoint += 100 * (rsplit.length - lsplit.length);
    }
    sortPoint +=  parseInt(articleR.maturity, 10) - parseInt(articleL.maturity, 10);

    //Que mais possui fases
    //Com maior maturidade
    return sortPoint;
  }

  onCellClick(row,col) {
    this.setState({
      // showInfo: true,
      currentRow: row,
      currentArticle: this.state.content.articlesProcessed[row]
    })
  }

  onRowSelection(rows) {
    if (rows.length ? true : (1 === this.state.content.rowsSelected.length)) {
      this.assign({
        rowsSelected: rows
      });
    }
  }

  /*handleSelect() {
    let current = this.state.content.rowsSelected;
    current.push(this.state.currentRow);
    this.assign({rowsSelected: current});
  }*/

  handleCloseDialog() {
    this.setState({
      showInfo: false
    })
  }

  render() {
    // console.log(this.state.content.rowsSelected);

    let methods = this.state.methods.map(j => { return {
      value: j.value,
      label: j.label + ' - ' + j.description
    }});
    let phases = this.state.phases.map(j => { return {
      value: j.value,
      label: j.label + ' - ' + j.description
    }});
    let objectives = this.state.objectives.map(j => { return {
      value: j.value,
      label: j.label + ' - ' + j.description
    }});

    return (
      <div>
        <Card>
          <CardTitle title="Identify the Guidelines" subtitle="3/5" />
          <CardText>
            <p>Often, an extensive list of available guidelines is presented. It should be necessary to filter the available guidelines according to specific needs.</p>
            <Select name="methods" placeholder="Research method(s)" multi
              options={methods}
              value={this.state.content.methods}
              onChange={(value) => { this.assign({ rowsSelected:[], methods: value }); }}
            />
            <Select name="phases" placeholder="Process phase(s)" multi
              options={phases}
              value={this.state.content.phases}
              onChange={(value) => { this.assign({ rowsSelected:[], phases: value }); }}
            />
            <Select name="objectives" placeholder="Type of instrument(s)" multi
              options={objectives}
              value={this.state.content.objectives}
              onChange={(value) => { this.assign({ rowsSelected:[], objectives: value }); }}
            />

            <Table
              selectable={true}
              multiSelectable={true}
              onCellClick={(row,col) => {this.onCellClick(row,col)}}
              onRowSelection={rows => {this.onRowSelection(rows)}}
              height='300px'
              >
                <TableHeader
                  displaySelectAll={true}
                  adjustForCheckbox={true}
                  enableSelectAll={true}
                  >
                  <TableRow>
                    <TableHeaderColumn>Instrument</TableHeaderColumn>
                    <TableHeaderColumn>Research method(s)</TableHeaderColumn>
                    <TableHeaderColumn>Process phase(s)</TableHeaderColumn>
                    <TableHeaderColumn>Type(s)</TableHeaderColumn>
                    <TableHeaderColumn>Maturity level</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {this.state.content.articlesProcessed
                    .map((linha, key) =>
                    <TableRow
                      selected={this.state.content.rowsSelected.includes(key)}
                      key={key}>
                      <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                        {linha.instrument}
                      </TableRowColumn>
                      <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                          {linha.methodsFm.map((j, mkey) =>
                            <div>
                              <Chip data-tip data-for={key+'met'+mkey} >
                                {j.label}
                              </Chip>
                              <ReactTooltip effect='solid' id={key+'met'+mkey}>
                                <span>{j.description}</span>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </TableRowColumn>
                      <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                          {linha.phasesFm.map((j, mkey) =>
                            <div>
                              <Chip data-tip data-for={key+'pha'+mkey} >
                                {j.label}
                              </Chip>
                              <ReactTooltip effect='solid' id={key+'pha'+mkey}>
                                <span>{j.description}</span>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </TableRowColumn>
                      <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                          {linha.objectiveFm.map((j, mkey) =>
                            <div>
                              <Chip data-tip data-for={key+'obj'+mkey} >
                                {j.label}
                              </Chip>
                              <ReactTooltip effect='solid' id={key+'obj'+mkey}>
                                <span>{j.description}</span>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </TableRowColumn>
                      <TableRowColumn style={{'text-overflow': null, 'white-space': null}}>
                        {linha.maturityFm}
                      </TableRowColumn>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </CardText>
            <CardTitle title="Choosen the suitable guidance" subtitle="Note the following heuristic approach to better choose the guidelines:" />
            <CardText>
              <ol>
                <li>Guidelines for conducting the research: Choose preferably the guideline papers addressing the whole process. If there is no such guideline, abuild a set of papers that covers all the intended phases;</li>
                <li>Context of the research: As some research methods present several available guidelines (e.g. case study, survey, experiment), we suggest you to screen the list keeping in mind the particular context of the intended research. Moreover, the discussion in [2] include some highlighted references that could be valuable;</li>
                <li>Multiple research methods: In case that your project employ a set related studies, browse also the guidelines addressing those research methods together;</li>
                <li>Mature guidelines: Give priority to evaluated (or otherwise validated) guidelines (as shown in maturity column);</li>
                <li>Assessment instruments: Add to your references the assessment instruments or checklists to assure that the planning and reporting meets the quality requirements. Note that some guidelines already include quality assessment steps;</li>
                <li>Classification schemes: If necessary for planning or reporting, read also classification schemes to support the methodology categorization.</li>
              </ol>
              <p>[2] Molléri J S, Petersen Kai and Mendes E. CERSE - Catalog for Empirical Research in Software Engineering - A Systematic Mapping Study.Information and Software Technology [under review] 2017.</p>
          </CardText>
        </Card>

        <Dialog
          title={this.state.currentArticle.instrument}
          actions={[
              /*<RaisedButton label="Selecionar" primary={true} onTouchTap={() => this.handleSelect()} />,*/
              <FlatButton label="Fechar" onTouchTap={() => this.handleCloseDialog()} />
          ]}
          modal={true}
          open={this.state.showInfo}
          >
          <p>
           {this.state.currentArticle.description}
           {/*this.state.currentArticle*/}
          </p>
        </Dialog>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/Step3.js